import { useMemo } from 'react';
import useRangeFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useRangeFilter';
import { createRangeSchema } from '@/creditflowresearch/ui/common/hooks/sidebar/rangeSchema';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';

const useIptPxd = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();
  const schema = useMemo(() => createRangeSchema({ bounds: filters?.iptPxd }), [filters?.iptPxd]);

  return useRangeFilter({ fromKey: 'includedIptPxdFrom', toKey: 'includedIptPxdTo', schema });
};

export default useIptPxd;
